// Checklist padrão e cópia congelada por vistoria. Protótipo: DEFAULT_CAT (518) e reloadChecklist (573).

import type { ItemChecklist } from './tipos.js';

export interface CategoriaPadrao {
  titulo: string;
  itens: { n: number; peso: number; descricao: string }[];
}

/** Checklist original do protótipo, com a numeração de origem (que tem buracos: 8, 18, 20, 32). */
export const CHECKLIST_PADRAO: readonly CategoriaPadrao[] = [
  { titulo: 'Geral', itens: [
    { n: 1, peso: 1.11, descricao: 'O alojamento possui pisos impermeáveis e laváveis.' },
    { n: 2, peso: 1.11, descricao: 'Existem monitoramento para garantir o controle de vetores conforme legislação local.' },
    { n: 3, peso: 4.17, descricao: 'As instalações elétricas são devidamente protegidas para evitar choques elétricos.' },
    { n: 4, peso: 4.17, descricao: 'A higienização do alojamento é realizada periodicamente, sendo os sanitários higienizados diariamente.' },
    { n: 5, peso: 1.11, descricao: 'Existe espaço para lazer e recreação dos trabalhadores alojados, podendo ser utilizado o espaço para refeições.' },
    { n: 6, peso: 1.11, descricao: 'É vedada a instalação e o uso de fogão, fogareiro ou similares, nos quartos.' },
    { n: 7, peso: 1.11, descricao: 'Os trabalhadores hospedados com suspeita de doença infectocontagiosa devem ser submetidos à avaliação médica que decidirá pelo afastamento ou permanência no alojamento.' },
  ] },
  { titulo: 'Área de Refeições / Cozinha', itens: [
    { n: 9, peso: 1.11, descricao: 'O refeitório/cozinha possui pisos e paredes revestidos com material impermeável e lavável.' },
    { n: 10, peso: 1.11, descricao: 'O refeitório/cozinha possui paredes pintadas ou revestidas com material lavável e impermeável.' },
    { n: 11, peso: 1.11, descricao: 'O refeitório/cozinha é arejado e ventilado, bem como apresenta boas condições de conservação, limpeza e higiene.' },
    { n: 12, peso: 3.33, descricao: 'O refeitório/cozinha atende conformavelmente os trabalhadores, contendo assentos e mesas suficientes.' },
    { n: 13, peso: 1.11, descricao: 'O refeitório/cozinha possui meios para conservação e aquecimento das refeições.' },
    { n: 14, peso: 1.11, descricao: 'O refeitório/cozinha possui condições para acondicionamento e disposição do lixo de acordo com as normas locais de controle de resíduos sólidos.' },
    { n: 15, peso: 1.11, descricao: 'O refeitório/cozinha possui local e material para lavagem de utensílios usados na refeição.' },
    { n: 16, peso: 4.17, descricao: 'É fornecido água potável, filtrada e fresca para os trabalhadores.' },
    { n: 17, peso: 4.17, descricao: 'Na hipótese de possuir fogão, o botijão de gás deve estar instalado fora da edificação, em área ventilada.' },
  ] },
  { titulo: 'Lavanderia', itens: [
    { n: 19, peso: 3.33, descricao: 'O alojamento dispõe de local e infraestrutura para lavagem e secagem de roupas dos alojados, ou é fornecido serviço de lavanderia.' },
  ] },
  { titulo: 'Instalações Sanitárias', itens: [
    { n: 21, peso: 4.17, descricao: 'As instalações sanitárias são dimensionadas na proporção de 1 (uma) instalação sanitária com chuveiro para cada 10 (dez) trabalhadores hospedados ou fração.' },
    { n: 22, peso: 3.33, descricao: 'As instalações sanitárias são individuais, conservadas e mantidas limpas e organizadas.' },
    { n: 23, peso: 4.17, descricao: 'As instalações sanitárias são compostas por lavatórios, bacias sanitárias sifonadas dotadas de assento com tampo.' },
    { n: 24, peso: 1.11, descricao: 'As instalações sanitárias possuem pisos e paredes revestidos por material impermeável e lavável.' },
    { n: 25, peso: 1.11, descricao: 'As instalações sanitárias possuem ventilação para o exterior ou sistema de exaustão forçada.' },
    { n: 26, peso: 1.11, descricao: 'As instalações sanitárias e chuveiros possuem portas de acesso que impeçam o devassamento.' },
    { n: 27, peso: 3.33, descricao: 'As instalações sanitárias possuem água canalizada e esgoto ligados à rede geral ou a outro sistema que não gere risco à saúde e que atenda à regulamentação local.' },
    { n: 28, peso: 1.11, descricao: 'As instalações de chuveiros possuem suporte para sabonete e toalha.' },
    { n: 29, peso: 3.33, descricao: 'Os compartimentos de sanitários possuem dimensões mínimas de 0,60 m de diâmetro entre a borda frontal da bacia sanitária e a porta fechada.' },
    { n: 30, peso: 3.33, descricao: 'Os compartimentos de chuveiros possuem dimensões mínimas de 0,80 × 0,80 m.' },
    { n: 31, peso: 1.11, descricao: 'Existem lixeiras com tampas para descarte de papéis usados.' },
  ] },
  { titulo: 'Dormitórios', itens: [
    { n: 33, peso: 4.17, descricao: 'Os quartos são mantidos em boas condições de conservação, higiene e limpeza.' },
    { n: 34, peso: 1.11, descricao: 'Os quartos possuem ventilação natural e artificial considerando as condições climáticas locais.' },
    { n: 35, peso: 4.17, descricao: 'Os quartos possuem capacidade máxima para 8 trabalhadores.' },
    { n: 36, peso: 4.17, descricao: 'Os quartos possuem, no mínimo, 3,00 m² por cama simples ou 4,50 m² por beliche (incluídas área de circulação e armário).' },
    { n: 37, peso: 4.17, descricao: 'Camas correspondentes ao número de trabalhadores alojados no quarto.' },
    { n: 38, peso: 3.33, descricao: 'Beliches com 2 camas na mesma vertical, respeitando espaçamento vertical e horizontal, permitindo ao alojado movimentação com segurança.' },
    { n: 39, peso: 3.33, descricao: 'As camas superiores dos beliches possuem proteção lateral e escada fixada à estrutura, livre de arestas ou rebarbas cortantes.' },
    { n: 40, peso: 3.33, descricao: 'Os colchões possuem certificação pelo INMETRO e estão em boas condições de uso.' },
    { n: 41, peso: 4.17, descricao: 'São disponibilizados lençóis, fronhas, cobertores e travesseiros limpos e higienizados, adequados às condições climáticas.' },
    { n: 42, peso: 4.17, descricao: 'Existem armários suficientes para o número de trabalhadores alojados.' },
    { n: 43, peso: 1.12, descricao: 'Os armários dos quartos são dotados de sistema de trancamento e com dimensões compatíveis para a guarda de roupas e pertences pessoais do trabalhador.' },
  ] },
];

export interface CategoriaVigente {
  titulo: string;
  itens: { peso: number; descricao: string }[];
}

/**
 * Cópia congelada do checklist em vigor, numerada em sequência (1..N), que é o que o
 * protótipo mostra e grava desde o reloadChecklist.
 */
export function congelarChecklist(categorias: readonly CategoriaVigente[]): ItemChecklist[] {
  let n = 1;
  return categorias.flatMap((c) => c.itens.map((it) => ({ n: n++, peso: it.peso, descricao: it.descricao, categoria: c.titulo })));
}

/** Checklist padrão como foi usado pelas vistorias antigas: numeração original ou sequencial. */
export function checklistPadrao(numeracao: 'sequencial' | 'original'): ItemChecklist[] {
  if (numeracao === 'sequencial') {
    return congelarChecklist(CHECKLIST_PADRAO.map((c) => ({ titulo: c.titulo, itens: c.itens })));
  }
  return CHECKLIST_PADRAO.flatMap((c) => c.itens.map((it) => ({ n: it.n, peso: it.peso, descricao: it.descricao, categoria: c.titulo })));
}

const SO_NA_SEQUENCIAL = [8, 18, 20, 32];

/**
 * Qual numeração uma vistoria antiga usou, pelas chaves das respostas: só a original tem itens
 * acima de 39; só a sequencial tem 8, 18, 20 ou 32. Sem nenhum dos dois sinais é 'ambigua'
 * (a importação desempata pela nota gravada).
 */
export function numeracaoDasRespostas(chaves: readonly number[]): 'sequencial' | 'original' | 'ambigua' {
  const orig = chaves.some((k) => k > 39);
  const seq = chaves.some((k) => SO_NA_SEQUENCIAL.includes(k));
  if (orig && !seq) return 'original';
  if (seq && !orig) return 'sequencial';
  return 'ambigua';
}

/** Agrupa a cópia congelada por categoria, na ordem (formulário e relatório). */
export function porCategoria(itens: readonly ItemChecklist[]): { titulo: string; itens: ItemChecklist[] }[] {
  const out: { titulo: string; itens: ItemChecklist[] }[] = [];
  for (const it of itens) {
    const ultima = out[out.length - 1];
    if (ultima && ultima.titulo === it.categoria) ultima.itens.push(it);
    else out.push({ titulo: it.categoria, itens: [it] });
  }
  return out;
}
